// extracted by mini-css-extract-plugin
export default {"flight":"nameFlight_flight__l6wI1","word":"nameFlight_word__QLdrh"};